"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/FileImage/ModalView.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Header = require('web/components/RightSide/Header');








/* The viewer's title bar, with Download and Close. Also shown while the
 * original loads or when it cannot be opened, so the viewer can always be
 * closed. */
 const ModalViewHeader = ({ imageCaption, onClose, onDownload }) => (
  _react2.default.createElement('div', { className: "blm-carousel--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
    , _react2.default.createElement('div', { className: "blm-carousel--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}},  imageCaption )
    , _react2.default.createElement('div', { className: "blm-carousel--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
      ,  onDownload && (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement(_Header.HeaderItem, {
            iconName: "download",
            'aria-label': "Download image" ,
            onClick: onDownload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
          )
          , _react2.default.createElement('div', { className: "blm-carousel--separator", __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}} )
        )
      )
      , _react2.default.createElement(_Header.HeaderItem, {
        iconName: "close",
        'aria-label': "Close image preview"  ,
        onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
      )
    )
  )
); exports.ModalViewHeader = ModalViewHeader








const FileImageModalView = ({
  imageSrc,
  imageCaption,
  onClose,
  onDownload,
}) => {
  const [isZoomedIn, setIsZoomedIn] = _react.useState.call(void 0, false)
  const toggleZoom = () => setIsZoomedIn(x => !x)

  const imgClassName = _classBuilder2.default.call(void 0, 'file-image--preview', { 'zoomed-in': isZoomedIn })

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(exports.ModalViewHeader, { imageCaption: imageCaption, onClose: onClose, onDownload: onDownload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}} )
      , _react2.default.createElement('div', { className: "file-image--preview-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
        , _react2.default.createElement('div', { className: "file-image--preview-container", __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
          , _react2.default.createElement('img', {
            onClick: toggleZoom,
            className: imgClassName,
            src: imageSrc,
            alt: imageCaption, __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
          )
        )
      )
    )
  )
}

exports. default = FileImageModalView
